export default __webpack_public_path__ + "static/media/Factory5.1c5ab7d5.jpg";